import z from "zod";
import { GoalEnum, PaymentMethodEnum, ProjectStatusEnum, TypeEnum } from "./common";

export const ListProjectFilter = z.object({
  query: z.string().optional(),
  district: z.string().optional().catch(undefined),
  status: ProjectStatusEnum.array().optional().catch(undefined),
  goal: GoalEnum.array().optional().catch(undefined),
  type: TypeEnum.array().optional().catch(undefined),
  payment: PaymentMethodEnum.array().optional().catch(undefined),
  beds: z.number().array().optional().catch(undefined),
  livingRooms: z.number().array().optional().catch(undefined),
  bathrooms: z.number().array().optional().catch(undefined),
  features: z.array(z.uuidv7()).optional().catch(undefined),
  minPrice: z.number().optional().catch(undefined),
  maxPrice: z.number().optional().catch(undefined),
  minArea: z.number().optional().catch(undefined),
  maxArea: z.number().optional().catch(undefined),
  exclude: z.uuid().optional().catch(undefined),
  favoriteProjectIds: z.uuidv7().array().optional().catch(undefined),
});

export type ListProjectsFilter = z.infer<typeof ListProjectFilter>;

export const ProjectRoomFilterOptionsSchema = z.object({
  bedrooms: z.number().array(),
  livingRooms: z.number().array(),
  bathrooms: z.number().array(),
});

export type ProjectRoomFilterOptions = z.infer<typeof ProjectRoomFilterOptionsSchema>;
